export const selfInfoUrl = () => {
  return "/self-id";
};

export const loadResultUrl = id => {
  const event_id = id.eventId;
  const competition_id = id.competitionId;
  return `/results/${event_id}/${competition_id}.json`;
};

export const submitResultUrl = id => {
  const event_id = id.eventId;
  const competition_id = id.competitionId;
  return `/results/${event_id}/${competition_id}.json`;
};

export const resultsListUrl = id => {
  const event_id = id.eventId;
  const competition_id = id.competitionId;
  return `/results/index/${event_id}/${competition_id}.json`;
};

export const destroyResultUrl = id => {
  return `/results/${id}.json`;
}
